import React, { useEffect, useState } from 'react'
import Banner from './Banner'
import './About.css'
import Footer from '../components/Footer'
import Gallery from './Gallery'
import { Link } from 'react-router-dom'
import { Button } from '@mui/material'

import SendIcon from '@mui/icons-material/Send';

const About = ({ galleryRef, contactRef }) => {
    const pageName = "About Us"


    return (
        <>
            <Banner pageName={pageName} />
            <section className='abt_cont'>
                <div className='container'>
                    <h5>
                        CarGenie is your trusted partner for all your car servicing needs. Our expert technicians use advanced tools and genuine parts to ensure your vehicle receives the best care possible. From routine 
                        maintenance to specialized detailing, we are committed to delivering quality service, transparency, and customer satisfaction. Experience hassle-free car care with CarGenie—where your vehicle’s 
                        health is our top priority.
                    </h5>
                    <div className='row'>
                        <div className='boxAbt'>
                            <div className='col-xs-12 col-lg-7'>
                                <h3>Our Mission</h3>
                                <p>
                                    At Car Genie, our mission is to provide reliable, affordable, and high-quality auto repair
                                    services to our community. We strive to ensure our customers feel confident and safe on the road.
                                </p>
                                <Link to="/Team">
                                    <Button variant="contained" size="medium" className='roundedBox buttonBlue' endIcon={<SendIcon />}> Meet our Team </Button>
                                </Link>
                            </div>
                            <div className='col-xs-12 col-lg-5'>
                                <img src="images/team.png" className='img-fluid' alt='carGenie' />
                            </div>
                        </div>

                        <div className='boxAbt reverse'>
                            <div className='col-xs-12 col-lg-5'>
                                <img src="images/transmission.png" className='img-fluid' alt='carGenie' />
                            </div>
                            <div className='col-xs-12 col-lg-7'>
                                <div className='endJustify'>
                                    <h3>Our Services</h3>
                                    <p>
                                        We offer a full range of auto repair services, including engine diagnostics, brake repair, tire
                                        rotation, and more. Our experienced team uses the latest tools and technology to provide top-notch service.
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div className='boxAbt'>
                            <div className='col-xs-12 col-lg-7'>
                                <h3>Our Warranty</h3>
                                <p>
                                    We stand behind our workmanship with a 24-month/10000KM warranty on all parts and labor. We want our customers
                                    to have peace of mind knowing they can rely on our services.
                                </p>
                            </div>
                            <div className='col-xs-12 col-lg-5'>
                                <img src="images/engine.png" className='img-fluid' alt='carGenie' />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* <Gallery ref={galleryRef}/> */}

            {/* <Footer ref={contactRef}/> */}
        </>
    )
}

export default About